export const storeVersion = 4;

export const onRehydrateStorage = (defaultData: any) => () => (state: any) => {
  if (state?.version !== storeVersion) {
    console.log(
      `Rehydrated version mismatch. Resetting state to version ${storeVersion}`
    );
    return {
      version: storeVersion,
      data: defaultData, 
    };
  }
  console.log(`Rehydrated state matches version ${storeVersion}`);
  return state;
};


export const migrate = (defaultData: any) =>  (persistedState: any, version: number) => {
    if (version !== storeVersion) {
      console.log(`Migrating from version ${version} to ${storeVersion}`);
      return {
        version: storeVersion,
        data: defaultData, 
      };
    }
    return persistedState;
  };